<p-popover #op (onShow)="onShow()" appendTo="body">
  <div
    #listEl
    class="tf-reaction-picker"
    role="menu"
    tabindex="-1"
    [attr.aria-label]="'COMMENTS.REACTIONS.PICKER_ARIA' | translate"
    (keydown)="onKeyDown($event)">
    @for (emoji of emojis; track emoji; let i = $index) {
      <button
        type="button"
        role="menuitem"
        class="tf-reaction-picker__emoji"
        [attr.tabindex]="focusedIndex() === i ? 0 : -1"
        [attr.aria-label]="'COMMENTS.REACTIONS.REACT_WITH' | translate: { emoji }"
        (click)="onSelect(emoji)">
        {{ emoji }}
      </button>
    }
  </div>
</p-popover>
